import { List, fromJS, Map } from 'immutable';
import * as filtersContoller from '../controllers/filtersController';
import { getFiltersFromUrl } from '../utils';
import * as searchConstants from '../constants/search';
import * as filterConstants from '../constants/filters';

import { prepareHotelNameFilter } from '../../../utils/filtersUtils';
import { SET_PREVIOUS_FILTERS } from '../../../store/previousFilters/constants';

const changeFilter = (state, { path, diff }) => {
  const filter = state.get(path);
  if (List.isList(filter)) {
    // Nested filter: filter is list of subfilters (i.e checkboxes)
    return state.update(path, (items) =>
      items.map((item) => {
        const diffForItem = Array.isArray(diff)
          ? diff.find((newItem) => newItem.id === item.get('id'))
          : diff.id === item.get('id') && diff;
        return diffForItem ? item.merge(diffForItem) : item;
      }),
    );
  }

  // Plain filter: value is not an array (i.e hotel name)
  return state.set(path, filter.merge(diff));
};

const prepareFilters = () => {
  const {
    filter_hotel_name: hotelName,
    filter_price_min: minPrice,
    filter_price_max: maxPrice,
    filter_distance_to_city_center: distanceToCityCenter,
  } = getFiltersFromUrl();
  const prices = {
    segments: [],
    minPrice: +minPrice || null,
    maxPrice: +maxPrice || null,
  };
  return fromJS({
    prices,
    hotel_name: prepareHotelNameFilter(hotelName as string),
    distance_to_city_center: { selected_max_distance: distanceToCityCenter },
  });
};

export default function filtersReducer(state = prepareFilters(), action) {
  switch (action.type) {
    case searchConstants.START_SEARCH_PROCESS:
      return prepareFilters().set(
        'mobileHotelFilter',
        state.get('mobileHotelFilter', Map()),
      );
    case searchConstants.SEARCH_SUCCESS: {
      const filters = { ...prepareFilters().toJS(), ...action.payload.filters };

      return fromJS(filters)
        .setIn(['hotel_name'], state.get('hotel_name', Map()))
        .setIn(
          ['prices', 'minPrice'],
          state.getIn(['prices', 'minPrice'], null),
        )
        .setIn(
          ['prices', 'maxPrice'],
          state.getIn(['prices', 'maxPrice'], null),
        )
        .setIn(['mobileHotelFilter'], state.get('mobileHotelFilter', Map()));
    }
    case filterConstants.CHANGE_FILTER:
      return changeFilter(state, action.payload);
    case filterConstants.CLEAR_FILTER: {
      const path = action.payload;
      const diff = filtersContoller.clearFilter(path, state.get(path));
      return changeFilter(state, { diff, path });
    }
    case filterConstants.CLEAR_FILTERS:
    case searchConstants.CHANGE_SEARCH_PARAMS: {
      let newState = state;
      const filtersList = state.keySeq().toArray();

      filtersList.forEach((path) => {
        const filterData = state.get(path);
        if (filterData) {
          const diff = filtersContoller.clearFilter(path, filterData);
          newState = changeFilter(newState, { diff, path });
        }
      });
      return newState;
    }
    case SET_PREVIOUS_FILTERS: {
      const previousFilters = fromJS(action.payload);
      return state.mergeDeep(previousFilters);
    }
    case filterConstants.SET_FILTERS:
      return action.payload.set(
        'mobileHotelFilter',
        state.get('mobileHotelFilter', Map()),
      );
    case filterConstants.TOGGLE_FILTER_REGION: {
      const regions = state.get('regions')?.toJS() || [];
      const newRegions = regions.map((region) => ({
        ...region,
        selected: region.id === action.payload.id,
      }));
      return state.set('regions', fromJS(newRegions));
    }
    case filterConstants.SET_MOBILE_HOTEL_FILTER_OPENED: {
      return state.setIn(
        ['mobileHotelFilter', 'isOpened'],
        fromJS(action.payload),
      );
    }
    default:
      return state;
  }
}
